import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { LabelValuePair, ScrBaseComponent } from 'src/app/components/base.component';
import { Account } from 'src/app/models/account.model';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { Lease } from 'src/app/models/lease.model';
import { AchPaymentMethod, Card } from 'src/app/models/payment.model';
import { TableColumn } from 'src/app/models/table-columns';
import { AccountService } from 'src/app/services/account.service';
import { ConfigService } from 'src/app/services/config.service';
import { PaymentMethodsService } from 'src/app/services/paymentmethod.service';
import { IOrderResponse, OrderTransaction, PendingOrderService } from 'src/app/services/pendingorder.service';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { CreditCardPipe } from 'src/app/shared/credit-card.pipe';
import { formatCurrency } from '@angular/common';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { defaults, pickBy, mapKeys, camelCase, cloneDeep, omit, range } from "lodash-es";
import { MonthlyInvoice } from 'src/app/models/monthlyinvoice.model';

import { ApplicationType, LeaseType, OrderStatus } from 'src/app/models/constants';
import { Address } from 'src/app/services/address-book.service';
import { ShortCodesRole, OrderTransactionType } from '../../../../models/constants';
import { BadgeService } from 'src/app/services/badge.service';
import { RouterService } from 'src/app/services/router.service';
import { ScrMessage } from 'src/app/services/base.service';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { IncomingState } from '../order-short-code.component';

/* eslint-disable  @typescript-eslint/no-explicit-any */
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent extends ScrBaseComponent implements OnInit, OnDestroy {

  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;

  account!: Account;
  public bulk = false;
  public paymentModeDebug = false;
  renewDirectBilledMonthly = false;
  pendingOrder = new BillingOrder();
  monthlyInvoice = new MonthlyInvoice();
  leasesForDisplay: Lease[] = [];
  publicEmailDomains: string[] = [];
  public tableColumn: TableColumn[] = [
    { field: 'scId', width: '3' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '3' },
    { field: 'price', width: '4' },
  ];
  public termOptions = [
    { label: '3-Month', value: 3 },
    { label: '6-Month', value: 6 },
    { label: '12-Month', value: 12 },
  ];

  public needsactionRenew = false;
  payNow = true;
  monthlyBilling?: boolean;
  cards: Card[] = [];
  selectedPayment = 0;
  newPaymentMethod = false;
  newcard: Card = new Card();
  achs: AchPaymentMethod[] = [];
  newach: AchPaymentMethod = new AchPaymentMethod();

  default = false;
  addToProfile = false;

  credit = 0;
  minOfCreditAndTotal: string | null = null;
  applyCredit = false;
  amountDueAfterCredit = 0;
  creditToBeApplied = 0;
  noPaymentDue = false;

  cardTypes: LabelValuePair[] = [];
  months: SelectItem<number>[] = [];
  years: SelectItem<number>[] = [];
  accountTypes: LabelValuePair[] = [
    { label: "Checking", value: "Checking" },
    { label: "Corporate Checking", value: "CorporateChecking" },
    { label: "Savings", value: "Saving" }
  ];
  cartLeases: Lease[] = [];
  cartPrice = 0;
  termAgreement?: boolean;
  bestPractices?: boolean;
  licenseAgreementDate?: string;
  licenseAgreementcontent?: string;
  bestPracticesContent?: string;
  bestPracticesDate?: string;
  licenseAgreementUrl?: string;
  pendingNavIsInternal = false;
  achIdentificationCode?: string;
  achMaxPaymentLimit = 500_000_000;

  @ViewChild(ConfirmDialog, { static: false }) confirmDialog!: ConfirmDialog;
  @ViewChild('f') ngForm!: NgForm;
  constructor(
    private configService: ConfigService,
    private accountService: AccountService,
    private pendOrderService: PendingOrderService,
    private cardService: PaymentMethodsService,
    private confirmationService: ConfirmationService,
    private shortCodeService: ShortCodesService,
    private badgeService: BadgeService,
    private router: Router,
    private routerService: RouterService
  ) {
    super();

    this.cardTypes = [
      { label: "Visa", value: "Visa" },
      { label: "Mastercard", value: "Mastercard" },
      { label: "Discover", value: "Discover" },
      { label: "American Express", value: "Amex" }
    ];

    this.newach.accountType = 'CorporateChecking';

    this.months = range(1, 13).map(v => {
      return { label: `${v}`.padStart(2, '0'), value: v };
    });

    const thisYear = new Date().getFullYear();
    this.years = range(12).map(v => {
      return { label: `${thisYear + v}`, value: thisYear + v };
    });
  }

  ngOnInit(): void {

    // restore these defaults.  Subsequent processing will fix
    // what might not be appropriate anymore (such as apply credit when not credit available).
    // the state can be supplied when coming from pay invoice.

    const makePaymentState = history.state as IncomingState;

    this.needsactionRenew = makePaymentState.needsactionRenew;

    const previous = this.routerService.getPreviousUrl();
    this.log.trace('ngOnInit - ' + previous);

    // if navigating internally within the checkout pages, we want to restore
    // the selected card, apply credit and paynow state.
    if (previous && previous.includes('order-code-tab')) {
      const previousPageState = this.pendOrderService.getPaymentPageState();
      if (previousPageState) {

        // if this is not a new order, we should reuse the previously saved state.
        this.payNow = previousPageState.payNowType;
        this.selectedPayment = previousPageState.selCardId;

        // only enable the apply credit check when previously set AND this payment supports it.
        this.applyCredit = previousPageState.applyCredit && this.supportsPayWithCredit();
      }
    }

    //Handle paylater - manual pay direct navigation
    if (makePaymentState.payLater) {
      this.shortCodeService.scPurchasePayLater = true;
    }
    if (makePaymentState.payLater || makePaymentState.manualPay) {
      makePaymentState.order.leases.forEach(l => l.selected = true);
      this.pendingOrder = makePaymentState.order;
      let tranType = makePaymentState.payLater && makePaymentState.renew ? OrderTransactionType.RenewPayLater
        : makePaymentState.payLater ? OrderTransactionType.NewPayLater
          : OrderTransactionType.ManualPayMonthlyBilling;
      if (tranType === OrderTransactionType.RenewPayLater && this.pendingOrder.renewalDeadLineStr) {
        tranType = OrderTransactionType.Renew1Plus12PayLater;
        this.pendingOrder.choseBilledMonthly = true;
        this.pendingOrder.enrollInMonthlyBilling = true;
      }
      if (tranType === OrderTransactionType.Renew1Plus12PayLater && this.pendingOrder.renewalAfterDeadline) {
        tranType = OrderTransactionType.Renew1Plus12AfterDeadline;
        this.pendingOrder.choseBilledMonthly = false;
        this.pendingOrder.enrollInMonthlyBilling = false;
      }

      this.pendOrderService.setOrderTransactionDetails(tranType, this.pendingOrder);
    }
    else if (!this.isNewOrder()) {
      //Bulk Renew?
      if (this.isBulkRenew()) {
        this.bulk = true;
      }
      //In between navigations  when not a new order
      this.pendingOrder = this.pendOrderService.orderTransaction$.value.transactionOrder;
      if (!this.bulk) {
        this.pendingOrder.leases.forEach((lease: { selected?: boolean; }) => { lease.selected = true; });
      }

      if (this.isRenewDirectIntoMB())
        this.pendingOrder.poNumber = undefined;
    }

    //Renew?
    if (this.isRenew()) {
      if (this.isRenewIntoMB()) {
        if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12) {
          this.renewDirectBilledMonthly = false;
          this.cartLeases = this.pendingOrder.leases;
          this.cartPrice = this.pendingOrder.totalPrice;
          this.pendingOrder.leases[0].term = 12;
          this.pendingOrder.leases[0].addToMb = true;
          this.pendingOrder.leases[0].autorenew = true;
        } else if (this.getOrderTransactionType() === OrderTransactionType.EnrollInMonthlyBilling) {
          this.renewDirectBilledMonthly = true;
          this.pendingOrder.leases[0].term = 12;
        } else if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12PayLater) {
          this.pendingOrder.leases[0].term = 12;
        }
        if (this.pendingOrder.leases[0].term === 12)
          this.pendingOrder.leases[0].leaseType = LeaseType.BilledMonthly;
      }
      else {
        // make sure the addToMB is off.
        this.pendingOrder.leases[0].addToMb = false;
      }
    }
    this.setLeaseForDisplay(this.pendingOrder.leases);
    //Paylater?
    if (this.isPayLater()) {

      this.pendingOrder.enrollInMonthlyBilling = this.leasesForDisplay[0].addToMb;
      if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12PayLater) {
        this.pendingOrder.enrollInMonthlyBilling = true;
      }
      if (this.pendingOrder.leases.filter(l => l.autorenew).length === this.pendingOrder.leases.length) {
        this.pendingOrder.enrollInAutoRenew = true;
      } else {
        this.pendingOrder.enrollInAutoRenew = false;
      }
    }

    //Monthly bill manual payment?
    if (this.isManualPayMonthlyBilling()) this.monthlyInvoice = this.createInvoiceOrder(makePaymentState['order']);

    // pull the account from the back end to be sure we have fresh data.
    this.accountService.getAccount(true).subscribe(rsp => {
      if (!this.isRenew()) {
        this.monthlyBilling = rsp.account.monBillEnabled;
      }
      this.account = rsp.account;

      if (this.getOrderTransactionType() === OrderTransactionType.New) {
        this.pendingOrder = this.pendOrderService.getPendingOrder();
        const source = pickBy(this.account, ((_, k) => k.startsWith('billing')));
        // note: defaults handles undefined but not null and somewhere billing phone becomes null.
        if (this.pendingOrder.billingPhone === null) {
          this.pendingOrder.billingPhone = source.billingPhone;
        }
        defaults(this.pendingOrder, source);
        this.setLeaseForDisplay(this.pendingOrder.leases);
      }

      if (!this.isRenewDirectIntoMB()) {
        this.credit = rsp.account.unappliedCredits || 0;
        this.processUpdatedAvailableCredit(rsp.account.unappliedCredits);
      }

    });

    this.configService.getConfig().subscribe(cfg => {
      this.licenseAgreementDate = cfg.licenseAgreement.updated;
      this.licenseAgreementcontent = cfg.licenseAgreement.content;
      // this.licenseAgreementUrl=cfg.
      this.achIdentificationCode = cfg.achIdentificationCode;
      this.achMaxPaymentLimit = cfg.achMaxPaymentLimit;
      this.publicEmailDomains = cfg.publicEmailDomains;
      this.bestPracticesContent = cfg.bestPractices.content;
      this.bestPracticesDate = cfg.bestPractices.updated;
    });

    //Card related stuff
    if (this.account?.accountType !== 'Carrier') {
      this.initPaymentMethods();
    }
  }

  /**
   * This is called if the account is not a carrier.
   * Pull the payment methods.
   */
  initPaymentMethods(): void {
    this.observe(this.cardService.retrievePaymentMethods(), res => {
      if (res.ach) {
        this.achs = res.ach;
        this.achs.forEach(ach => {
          ach.paymentType = 'ach';
          if (this.achs.length > 0) { //Make sure it was not saved in localstorage
            const defaultAch = this.achs.find(ach => ach.defaultPaymentMethod);
            if (defaultAch !== undefined) {
              this.newPaymentMethod = false;
              this.selectedPayment = defaultAch.achPaymentMethodId;
            } else {
              this.newPaymentMethod = false;
              this.selectedPayment = this.achs[0].achPaymentMethodId;
            }
          } else {
            this.newPaymentMethod = true;
            this.selectedPayment = 0;
          }
        });
      }

      if (res.creditcard) {
        this.cards = res.creditcard;
        this.cards.forEach(card => {
          card.paymentType = 'card';
        });
        const cards = this.cards.filter(card => !this.isExpired(card));
        if (cards.length > 0) {//Make sure it was not saved in localstorage
          const defaultCard = cards.filter(card => card.default);
          if (defaultCard.length > 0) {
            this.newPaymentMethod = false;
            this.selectedPayment = defaultCard[0].creditCardId;
          }
          if (!(this.achs.length > 0) && !(defaultCard.length > 0)) {
            this.newPaymentMethod = false;
            this.selectedPayment = cards[0].creditCardId;
            const cardFound = this.cards.findIndex(cardWithId => cardWithId.creditCardId === this.selectedPayment);
            if (cardFound === -1) {
              this.newPaymentMethod = true;
              this.selectedPayment = 0; // reset it if the card does not exist anymore
            }
          }
        }
      }

      if (!(this.achs.length > 0) && !(this.cards.length > 0)) {
        this.newPaymentMethod = true;
        this.selectedPayment = 0;
      }

      // work around for edge case where cards exist but all are expired.  If that is the
      // case, there will be no selected payment and zero (new card) will be set but the
      // newPaymentMethod check will not be set.
      if (this.selectedPayment === 0 || this.selectedPayment === 1) {
        this.newPaymentMethod = true;
      }

      if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12AfterDeadline
        && this.pendingOrder.renewalAfterDeadline) {
        this.displayLocalizedWarning('scr.renewaldeadlinepassed');

      }
      if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12PayLater
        && this.pendingOrder.allMBDiscountsNotApplied) {
        this.displayLocalizedWarning('scr.renew1plus12BilledMonthlyDiscountNotApplied');
      }
      return false;
    });
  }

  /**
   * The back-end has reported an available credit amount.  This could
   * be on init of the page or in response to a difference from what
   * we tried to use in our request.  We need to redo some of the math.
   * @param amount - updated amount returned from back-end
  */
  processUpdatedAvailableCredit(amount: number | undefined) {
    if (amount !== undefined) {
      this.credit = amount;
      // back-end sends us a zero (not null) when account is depleted of credit.
    }
    else {
      this.credit = 0;
    }
    if (this.credit === 0) {
      this.applyCredit = false;
    }
    this.updateMinOfCreditAndTotal();
    this.updateAmountDue();
  }

  updateAmountDue() {
    if (this.applyCredit) {
      if (this.isRenew1Plus12()) {
        const oneMonthLease = this.leasesForDisplay.find(l => l.term === 1);
        this.creditToBeApplied = Math.min(this.credit, (oneMonthLease?.price ?? 0));
        this.amountDueAfterCredit = Math.round(100 * ((oneMonthLease?.price ?? 0) - this.creditToBeApplied)) / 100;
      }
      else {
        this.creditToBeApplied = Math.min(this.credit, this.pendingOrder.totalPrice);
        this.amountDueAfterCredit = Math.round(100 * (this.pendingOrder.totalPrice - this.creditToBeApplied)) / 100;
      }
    }
    else {
      this.creditToBeApplied = 0;
      if (this.isRenew1Plus12()) {
        const oneMonthLease = this.leasesForDisplay.find(l => l.term === 1);
        this.amountDueAfterCredit = (oneMonthLease?.price ?? 0);
      }
      else {
        this.amountDueAfterCredit = this.pendingOrder.totalPrice;
      }
    }
    this.noPaymentDue = (this.amountDueAfterCredit === 0);
  }

  updateMinOfCreditAndTotal(): void {
    if (this.isRenew1Plus12()) {
      const oneMonthLease = this.leasesForDisplay.find(l => l.term === 1);
      this.minOfCreditAndTotal = formatCurrency(Math.min(this.credit, (oneMonthLease?.price ?? 0)), 'en-US', '$');
    }
    else {
      this.minOfCreditAndTotal = formatCurrency(Math.min(this.credit, this.pendingOrder.totalPrice), 'en-US', '$');
    }

    if (!this.credit || this.credit === 0) {
      this.applyCredit = false;
    }
  }


  setLeaseForDisplay(leases: Readonly<Lease>[]): void {
    // filter out those leases not selected (the checkboxes on the cart tab).
    this.leasesForDisplay = leases.filter(lease => lease.selected);
    let isDiscounted = this.leasesForDisplay.find(lease => { if (lease.discountAmount && lease.discountAmount > 0) return lease.discountAmount > 0; else return false; });
    isDiscounted = this.leasesForDisplay.find(lease => { if (lease.discountList && lease.discountList.length > 0) return lease.discountList.length > 0; else return false; });
    if (isDiscounted) {
      this.tableColumn = [
        { field: 'scId', width: '3' },
        { field: 'shortCodeType', width: '3' },
        { field: 'term', width: '3' },
        { field: 'listPrice', width: '4' },
        { field: 'discount', width: '6' },
        { field: 'price', width: '4' },
      ];
    }
    else {
      this.tableColumn = [
        { field: 'scId', width: '3' },
        { field: 'shortCodeType', width: '3' },
        { field: 'term', width: '3' },
        { field: 'listPrice', width: '3' },
        { field: 'price', width: '4' },
      ];
    }
    this.localizeTableColumns(this.tableColumn);
  }

  // When we are leaving this page
  override ngOnDestroy(): void {
    super.ngOnDestroy();

    // save the state just in case we need to restore it in ngOnInit.
    if (this.pendingNavIsInternal) {
      const previousPageState = this.pendOrderService.getPaymentPageState();
      previousPageState.applyCredit = this.applyCredit;
      previousPageState.selCardId = this.selectedPayment;
      previousPageState.payNowType = this.payNow;
      this.pendOrderService.savePaymentPageState(previousPageState);
    }
    else {
      this.pendOrderService.leavingCheckoutPages();
    }

    const transType = this.getOrderTransactionType();
    if (this.isManualPayMonthlyBilling()) { //reset it completely for pay with card for monthly bill
      this.pendOrderService.setOrderTransactionDetails(OrderTransactionType.New, new BillingOrder());
      return;
    }
    //Navigating back and forth internally in order tab - //Should never be empty when doing the three order tabs
    if (!this.isNewOrder()) {
      if (transType === OrderTransactionType.Renew1Plus12) {
        this.pendingOrder.leases = this.cartLeases; //reset it to Billed Monthly term.
        this.pendingOrder.totalPrice = this.cartPrice; // reset it when leaving the payment.
      }
      this.pendOrderService.setOrderTransactionDetails(transType, this.pendingOrder);
      return;
    }
    //NonNewOrders Navigates away from order tab alltogether,reset it to  new order type in parent but pendingOrder is set to empty here)
    if (this.isNewOrder() &&
      (this.pendingOrder.applicationType === ApplicationType.Renew ||
        this.pendingOrder.orderId !== null && this.pendingOrder.orderId !== undefined)) {
      this.pendingOrder = new BillingOrder();
      this.termAgreement = false;
      this.bestPractices = false;
      this.payNow = true;
      this.newPaymentMethod = true;
      this.selectedPayment = 0;
    }
    else {
      if (this.pendOrderService.keepTheCode) {
        const ot = new OrderTransaction(this.pendingOrder, transType);
        this.pendOrderService.emitChangePendOrder(ot);
      }
      // TODO: why do we need to update anything in "this" since we are being destroyed.
      else {
        this.pendingOrder = new BillingOrder();
        this.termAgreement = false;
        this.bestPractices = false;
        this.payNow = true;
        this.newPaymentMethod = true;
        this.selectedPayment = 0;
        this.pendOrderService.removeAllOrder(transType);

        // we saved it by default, but here blow away the state of the page.
        this.pendOrderService.removePaymentPageState();
      }
    }
  }

  achSummary(ach: AchPaymentMethod) {
    const {
      bankName,
      limit,
      lastFourDigits,
      description,
      defaultPaymentMethod: isDefault
    } = ach;

    const ml = formatCurrency(limit, 'en-US', '$');
    return `ACH ${bankName} ****${lastFourDigits} ${description || ''} (Max Limit: ${ml}) ${isDefault ? ' (Default)' : ''}`;
  }

  cardSummary(card: Card): string {
    const {
      cardType,
      lastFourDigits,
      expirationMonth,
      expirationYear,
      description,
      default: isDefault
    } = card;
    const mm = `${expirationMonth}`.padStart(2, '0');

    return `${new CreditCardPipe().transform(cardType)} ****${lastFourDigits} ` +
      `(${this.isExpired(card) ? 'Expired ' : ''}${mm}/${expirationYear}) ` +
      `${description || ''}${isDefault ? ' (Default)' : ''}`;

  }

  /**
   * Shows warning only if the transaction type is renew1plus12, and that too only if it is not paynow and 
   * when there is discount applied for billed monthly
   * @returns 
   */
  showRenew1Plus12Warning() {
    this.clearMessages();
    if (this.getOrderTransactionType() !== OrderTransactionType.Renew1Plus12)
      return;
    else if (!this.payNow && this.getDiscountList(this.pendingOrder.leases[0]).length > 0) { //Get the discount for Billed Monthly at this time
      this.displayLocalizedWarning('scr.renew1plus12BilledMonthlyDiscountWarning');
    }
  }

  isExpired({ expirationMonth, expirationYear }: Card): boolean {
    const today = new Date();

    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    const yyyymm = (month: number, year: number): number => {
      const mm = `${month}`.padStart(2, '0');
      return +`${year}${mm}`;
    };

    return yyyymm(month, year) > yyyymm(expirationMonth, expirationYear);
  }

  cancelOrder(): void {
    if (!this.isNewOrder()) {
      this.simplyCancel();
    }
    else {
      this.cancelNewOrder();
    }
  }

  simplyCancel(): void {
    this.pendOrderService.leavingCheckoutPages();
    if (this.bulk || this.needsactionRenew)
      setTimeout(() => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-needs-action'] } }] } }]);
      }, 500);
    else
      setTimeout(() => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }]);
      }, 500);
  }

  cancelNewOrder(): void {
    this.confirmationService.confirm({
      message: `<p>Please confirm that you want to empty your cart and cancel this order.</p>`,
      header: 'Clear Order?',
      key: 'canOrder',
      accept: () => {
        this.confirmDialog.unbindGlobalListeners();
        this.pendingOrder = new BillingOrder();
        this.pendOrderService.removeAllOrder(OrderTransactionType.New);
        this.termAgreement = false;
        this.bestPractices = false;
        this.payNow = true;
        this.newPaymentMethod = true;
        this.selectedPayment = 0;
        this.pendOrderService.saveOrder(false);
        this.pendOrderService.leavingCheckoutPages();
        this.router.navigate([
          '/dashboard',
          {
            outlets: {
              'navbar-tab': [
                'order-code',
                { outlets: { 'order-code-tab': ['cart'] } },
              ],
            },
          },
        ]);
      },
      reject: () => {
        this.confirmDialog.unbindGlobalListeners();
      },
    });
  }

  addToProfileUpdate(e: CheckboxChangeEvent): void {
    if (!e.checked) {
      // if add to profile is false, set default to false as well.
      this.default = false;
    }
  }

  submit({ form }: NgForm) {

    const transType = this.getOrderTransactionType();
    let cc: Card | undefined;
    let ach: AchPaymentMethod | undefined;
    if (this.selectedPayment === 0) {
      cc = this.newcard;
      cc.default = this.default;
      cc.addCardToProfileAfterCheckout = this.addToProfile;
    }
    else if (this.selectedPayment === 1) {
      ach = this.newach;
      ach.defaultPaymentMethod = this.default;
      ach.addToProfileAfterCheckout = this.addToProfile;
    }
    else {
      cc = this.cards.find(c => c.creditCardId === this.selectedPayment);
      if (!cc) {
        ach = this.achs.find(a => a.achPaymentMethodId == this.selectedPayment);
      }
    }

    if (ach && ach.limit < this.amountDueAfterCredit && form.valid && this.payNow) {
      this.clearErrors();
      this.displayLocalizedError('scr.ach.lowlimit');
      this.jumpToTop();
      return;
    }

    // populate default values into the credit card using the billing fields.
    const billingFields = pickBy(this.pendingOrder, ((v, k) => k.startsWith('billing')));
    defaults(cc, mapKeys(billingFields, (v, k) => {
      return camelCase(k.replace('billing', ''));
    }));

    this.clearMessages();

    // short circuit processing of the submit if the form is not valid.
    if (!form.valid) {
      form.markAllAsTouched();
      for (const field in form.controls) {
        form.controls[field].markAsDirty();
      }
      this.scrollToFirstError();
      return;
    }

    this.pendingOrder = this.pendOrderService.createBillingOrderToComplete(this.pendingOrder, transType);
    if (this.isManualPayMonthlyBilling()) { this.monthlyInvoice = this.createInvoiceOrder(this.pendingOrder); }
    const ot = new OrderTransaction(this.pendingOrder, transType);
    this.pendOrderService.emitChangePendOrder(ot);

    if (this.account?.accountType === 'Carrier') {
      this.payNow = false;
    }

    // Convert ACH on Valid submit
    if (ach) {
      ach.limit = Number(ach.limit);
    }

    if (this.isPayLater()) {
      this.observe(this.pendOrderService.payForOrder(this.pendingOrder, cc, ach,
        this.applyCredit ? this.creditToBeApplied : undefined), {
        onSuccess: res => {
          this.emitAnalytics(res, 'payment');
          if (res.status === 'success') {
            if (this.account.unappliedCredits) {
              const creditLeft = this.applyCredit ? this.credit - this.creditToBeApplied : this.credit;
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', res.order.orderId] } }], { state: { availableCredit: creditLeft } });
            } else {
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', res.order.orderId] } }]);
            }
          }
          return false;
        },
        onFailure: res => {
          this.handleSpecialCaseErrorMessages(res.messages);
          return true;
        }
      });
    } else if (this.isManualPayMonthlyBilling()) {
      this.observe(this.pendOrderService.payForMonthlyInvoice(this.monthlyInvoice, cc, ach, this.applyCredit ? this.creditToBeApplied : undefined
      ), {
        onSuccess: res => {
          if (res.status === 'success') {
            if (this.account.unappliedCredits) {
              const creditLeft = this.applyCredit ? this.credit - this.creditToBeApplied : this.credit;
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', res.monthlyInvoice.monthlyInvoiceId] } }], { state: { availableCredit: creditLeft } });
            } else {
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', res.monthlyInvoice.monthlyInvoiceId] } }]);
            }
            this.updateBadgeCount();
          }
          return false;
        },
        onFailure: res => {
          this.handleSpecialCaseErrorMessages(res.messages);
          return true;
        }
      });
    } 
    else if (this.isRenewDirectIntoMB()) {
      this.observe(this.pendOrderService.submitOrder(
        'renewInMB',
        this.pendingOrder,
        undefined,
        undefined,
        this.applyCredit ? this.creditToBeApplied : undefined
      ), {
        onSuccess: res => {
          if (res.status === 'success') {
            this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', res.order.orderId] } }]);
          }
        }, onFailure: res => {
          if (res.messages) {
            this.displayErrorMessage(res.messages[0].message);
            this.handleSpecialCaseErrorMessages(res.messages);
            return true;
          }
          return false;
        }
      }
      );
    }
    else {

      let onePlusTwelveLease: Lease | undefined;
      if (this.isRenew1Plus12() && this.pendingOrder.leases.length === 2) {
        onePlusTwelveLease = this.specialProcessRenew1Plus12LeaseList();
      }

      let paymentMode = this.account?.accountType === 'Carrier' ? 'submit' :
        this.bulk ? 'bulkrenew' :
          this.payNow ? 'paynow' : 'paylater';

      if (!this.payNow && paymentMode === 'bulkrenew') {
        paymentMode = 'bulkRenewPayLater';
      }

      this.observe(this.pendOrderService.submitOrder(
        paymentMode,
        this.pendingOrder,
        this.payNow || this.bulk ? cc : undefined,
        this.payNow || this.bulk ? ach : undefined,
        this.applyCredit ? this.creditToBeApplied : undefined
      ), {
        onSuccess: res => {
          if (res.status === 'success') {
            this.emitAnalytics(res, 'purchase');

            if (this.isNewOrder()) {
              this.pendOrderService.removeAllOrder(OrderTransactionType.New);
              this.pendOrderService.saveOrder(false);
            }
            if (this.account.unappliedCredits) {
              const creditLeft = this.applyCredit ? this.credit - this.creditToBeApplied : this.credit;
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', this.getOrderIds(res.order)] } }], { state: { availableCredit: creditLeft } });
            }
            else {
              this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['thank-you', this.getOrderIds(res.order)] } }]);
            }
          }
        }, onFailure: res => {
          this.handleSpecialCaseErrorMessages(res.messages);

          // back end has sent us an updated order.
          if (res.order) {
            const transType = this.getOrderTransactionType();
            // we may have deleted the billed monthly lease so put it back.
            this.pendingOrder = res.order;
            if (onePlusTwelveLease) {
              this.pendingOrder.leases.unshift(onePlusTwelveLease);
              onePlusTwelveLease = undefined;
            }
            this.setLeaseForDisplay(this.pendingOrder.leases);
            this.updateAmountDue();
            const ot = new OrderTransaction(this.pendingOrder, transType);
            this.pendOrderService.emitChangePendOrder(ot);
            this.pendOrderService.setOrderTransactionDetails(ot.transactionType, this.pendingOrder);
          }
          else {
            // no updated order was returned but we may have deleted the one plus twelve.
            if (onePlusTwelveLease) {
              this.pendingOrder.leases.unshift(onePlusTwelveLease);
              onePlusTwelveLease = undefined;
            }
          }
          return true;
        }
      });
    }
  }

  emitAnalytics(rsp: IOrderResponse, pp: 'payment' | 'purchase') {
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase

    const firstOrderForAcct = rsp.meta.orderCount === 1 ? 'true': 'false'

    // GA Purchase and Payment Event Start
    if (pp === 'payment') {
      this.analyticsService.emitPayment(
        firstOrderForAcct,
        this.pendingOrder
      );
    }
    else {
      // this was a purchase.  could be for pay now or pay layer.
      const paidOrNotPaid = (rsp.order.orderStatus === OrderStatus.PaymentDue) ? 'not paid' : 'paid';
      this.analyticsService.emitPurchase(
        paidOrNotPaid,
        firstOrderForAcct,
        this.pendingOrder
      );
    }
  }

  getOrderIds(orders: any) {
    if (orders.length > 0) {
      return orders.map((order: BillingOrder) => order.orderId).join(',');
    } else {
      return orders.orderId;
    }
  }

  handleSpecialCaseErrorMessages(messages?: ScrMessage[]): void {
    if (!messages) {
      return;
    }
    messages.forEach(m => {
      if ((m.code === '4028') && m.data) {
        if (m.data.achPaymentMethodId && m.data.limit) {
          const match = this.achs.find(a => a.achPaymentMethodId === m.data.achPaymentMethodId);
          if (match) {
            match.limit = m.data.limit;
          }
          else {
            this.log.warn('back end sent me a new limit for an ach I do not have.');
          }
        }
      }
      if (m.data?.accountAvailableCredit !== undefined) {
        // one of the messages includes updated credit.
        this.processUpdatedAvailableCredit(m.data.accountAvailableCredit);
      }
    });
  }

  updateBadgeCount() {
    this.badgeService.updateLocally(data => {
      data.monthlyInvoiceCount = data.monthlyInvoiceCount >= 1 ? data.monthlyInvoiceCount - 1 : 0;
      return data;
    });
  }

  isPayLater(): boolean {
    const transType = this.getOrderTransactionType();

    return (transType === OrderTransactionType.NewPayLater ||
      transType === OrderTransactionType.RenewPayLater ||
      transType === OrderTransactionType.Renew1Plus12PayLater ||
      transType === OrderTransactionType.Renew1Plus12AfterDeadline);
  }


  isManualPayMonthlyBilling(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.ManualPayMonthlyBilling;
  }


  isRenew(): boolean {
    const transType = this.getOrderTransactionType();

    return (transType === OrderTransactionType.Renew ||
      transType === OrderTransactionType.RenewPayLater ||
      transType === OrderTransactionType.Renew1Plus12PayLater ||
      transType === OrderTransactionType.EnrollInMonthlyBilling ||
      transType === OrderTransactionType.Renew1Plus12 ||
      transType === OrderTransactionType.Renew1Plus12AfterDeadline);
  }

  isBulkRenew(): boolean {
    const transType = this.getOrderTransactionType();
    return (transType === OrderTransactionType.BulkRenew);
  }

  isRenewDirectIntoMB(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.EnrollInMonthlyBilling; // || saveType === OrderTransactionType.Monthly1Plus12;
  }

  isRenewIntoMB(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.EnrollInMonthlyBilling ||
      transType === OrderTransactionType.Renew1Plus12 ||
      transType === OrderTransactionType.Renew1Plus12PayLater;
  }

  ifRenew1Plus12DeadlinePassed(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.Renew1Plus12AfterDeadline;
  }


  supportsPayWithCredit(): boolean {
    const transType = this.getOrderTransactionType();
    return transType !== OrderTransactionType.EnrollInMonthlyBilling;
  }

  /**
   * If the user has credit and this is a flow with a payment, display
   * the blurb text explaining that they can use their credit.
   */
  showPayWithCreditAfterCheckBoxSelection() {
    const transType = this.getOrderTransactionType();
    return this.credit > 0 && !this.applyCredit && transType !== OrderTransactionType.EnrollInMonthlyBilling;
  }

  isRenew1Plus12(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.Renew1Plus12 || transType === OrderTransactionType.Renew1Plus12PayLater;
  }

  isNewOrder(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.New;
  }

  getOrderTransactionType(): OrderTransactionType {
    return this.pendOrderService.orderTransaction$.value.transactionType;
  }

  getDiscountList(lease: Lease) {
    if (!lease.discountList || lease.discountList.length === 0) {
      return '';
    }
    else {
      return lease.discountList.map(disc => disc.displayName).join(', ');
    }
  }

  /**
   * Create a monthly invoice from an order.  We need to submit a monthly invoice but the
   * payment page really doesn't know how to deal with them.  It only does orders.
   * @param oiObj - billing order.
   * @returns 
   */
  createInvoiceOrder(oiObj: BillingOrder): MonthlyInvoice {
    const mi = new MonthlyInvoice();
    const remove = ['leases', 'orderId', 'orderStatus', 'orderType'];
    defaults(mi, cloneDeep(omit(oiObj, remove)));
    return mi;
  }

  loadAddress(address: Address) {
    this.pendingOrder.billingFirstName = address.firstName;
    this.pendingOrder.billingLastName = address.lastName;
    this.pendingOrder.billingPhone = address.phone;
    this.pendingOrder.billingPhoneExtension = address.phoneExtension;
    this.pendingOrder.billingEmail = address.email;
    this.pendingOrder.billingAddress1 = address.address1;
    this.pendingOrder.billingAddress2 = address.address2;
    this.pendingOrder.billingCity = address.city;
    this.pendingOrder.billingState = address.state;
    this.pendingOrder.billingZip = address.zip;
    this.pendingOrder.billingCountry = address.country;
  }

  specialProcessRenew1Plus12LeaseList(): Lease | undefined {

    const priceFor1Month = this.pendingOrder.leases[1].price;
    const unitPrice = this.pendingOrder.leases[1].unitPrice;
    const termFor1Month = this.pendingOrder.leases[1].term;
    const listPriceFor1Month = this.pendingOrder.leases[1].listPrice;
    const discList = this.pendingOrder.leases[1].discountList;
    const discAmt = this.pendingOrder.leases[1].discountAmount;
    const pricingHash = this.pendingOrder.leases[1].pricingHash;
    const leaseType = this.pendingOrder.leases[1].leaseType;

    Object.assign(this.pendingOrder.leases[1], this.pendingOrder.leases[0]);

    this.pendingOrder.leases[1].price = priceFor1Month;
    this.pendingOrder.leases[1].unitPrice = unitPrice;
    this.pendingOrder.leases[1].term = termFor1Month;
    this.pendingOrder.leases[1].listPrice = listPriceFor1Month;
    this.pendingOrder.leases[1].discountList = discList;
    this.pendingOrder.leases[1].discountAmount = discAmt;
    this.pendingOrder.leases[1].pricingHash = pricingHash;
    this.pendingOrder.leases[1].leaseType = leaseType;
    this.pendingOrder.leases[1].autorenew = false;

    const rv = this.pendingOrder.leases.shift();
    this.pendingOrder.numberOfCodes = 1;
    this.pendingOrder.totalPrice = this.pendingOrder.leases[0].price ?? 0;
    return rv;
  }


  // Overwrite it here to handle the data
  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot
  ): boolean {

    const nextURL = currentState?.url;
    this.log.trace('currentState next URL ' + nextURL);
    this.pendingNavIsInternal = (nextURL.includes('order-code-tab:cart)') ||
      nextURL.includes('order-code-tab:application'));
    return true;
  }

  // Helper for prevent double-click directive. Just submits the form from view child. So, the subscription has an event.
  submitForm(event: PointerEvent) {
    this.ngForm.onSubmit(event);
  }

  newPaymentMethodSetup() {
    this.selectedPayment = 0;
  }
  clearNewPM() {
    this.newPaymentMethod = false;
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }
}
